export default {"src":"/_next/static/media/onepair-logo.111b5d2f.svg","height":32,"width":156,"blurWidth":0,"blurHeight":0};